<template>
  <v-app>
    <v-toolbar app dark style="background-color: #005f7b;">
      <v-btn icon @click="goBack" v-if="$route.meta.hasBackButton">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class="headline">
        Werktijd.be
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="logout" v-if="$route.path !== '/aanmelden'">
        <v-icon>logout</v-icon>
      </v-btn>
    </v-toolbar>

    <v-content>
      <router-view/>
    </v-content>
    <v-snackbar v-model="snackbarVisible" top :timeout="3000">{{ snackbarMsg }}</v-snackbar>
    <v-dialog v-model="confirmVisible" persistent>
      <v-card>
        <v-card-text>{{ confirmText }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" @click="confirmNo">Annuleren</v-btn>
          <v-btn color="primary" @click="confirmYes">Bevestigen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVisible">
      <v-card>
        <v-card-text>{{ dialogText }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="hideDialog">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  export default {
    name: 'App',
    data: function() { return {
      snackbarVisible: false
    }},
    computed: mapState(['api', 'snackbarMsg', 'dialogVisible', 'dialogText', 'confirmVisible', 'confirmText', 'confirmResolver']),
    methods: {
      ...mapMutations(['hideDialog', 'hideConfirm', 'setAuthToken']),
      logout: function() {
        this.api.post('afmelden')
        localStorage.removeItem('authToken')
        this.setAuthToken("")
        this.$router.push('/aanmelden')
      },
      confirmNo: function() {
        this.hideConfirm()
        this.confirmResolver(false)
      },
      confirmYes: function() {
        this.hideConfirm()
        this.confirmResolver(true)
      },
      goBack: function() {
        this.$router.push('/')
      }
    },
    watch: {
      snackbarMsg (newValue) {
        if (newValue !== "") this.snackbarVisible = true
      }
    }
  }
</script>

<style lang="stylus">
  .v-snack__wrapper
    padding: 6px 0 2px 0
</style>